import { Col, Row, Skeleton } from "antd";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface IProps {
    socials: JSX.Element[];
}


export const ComponentSocialMedia = (props: IProps) => {
    //page props
    const { socials } = props;
    const { t } = useTranslation();
    return (
        <StyledContainer>
            <p className="label-sginup">{t("page.please_proceed_with_LINE")}</p>
            <Row gutter={8}>
                {socials.map((item, index) => {
                    return (
                        <Col span={24 / socials.length} key={index}>
                            {item}
                        </Col>
                    );
                })}
            </Row>
        </StyledContainer>
    );
};

const StyledContainer = styled.div``;
